<div class="login-background w-full h-full bg-contain bg-left bg-no-repeat flex justify-center items-center">
  <div class="w-1/3">
    <div class="text-center flex justify-center items-center flex-col">
      <!--<div class="login-logo logo-min-size w-full max-w-xl"></div>-->
      <div class="logo-container ">
        <div class="logo align-middle"></div>
      </div>
      <h3 class="login-font-title font-light max-h-fit">
        {{ translationPath + 'loginDescriptionText' | translate }}
      </h3>
    </div>
    <div class="flex justify-center flex-col items-center">
      <div class="input-gray w-52 flex justify-center items-center flex-col margin-b">
        <form
          name="login"
          #loginForm="ngForm"
          class="w-full mb-1 flex flex-col items-center"
          (ngSubmit)="submitLogin(loginForm)"
        >
          <mat-form-field class="w-full margin-b">
            <input
              matInput
              [placeholder]="'common.labels.user' | translate"
              [(ngModel)]="pageData.user"
              (ngModelChange)="onUsernameChange($event)"
              #usernameModel="ngModel"
              required
              name="user"
              tabindex="1"
            />
            <mat-error
              *ngIf="
                usernameModel.invalid &&
                (usernameModel.dirty || usernameModel.touched)
              "
            >
              <mat-error
                *ngIf="usernameModel.errors.required"
                class="input-gray__error"
              >
                {{ translationPath + 'requiredUserMessage' | translate }}
              </mat-error>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="w-full margin-b">
            <input
              matInput
              [placeholder]="'common.labels.password' | translate"
              [(ngModel)]="pageData.password"
              #passwordModel="ngModel"
              required
              [type]="_hideText ? 'password' : 'text'"
              name="password"
              tabindex="2"
            />

            <mat-icon
              matSuffix
              class="cursor-pointer"
              (click)="_hideText = !_hideText"
            >
              {{ _hideText ? 'visibility' : 'visibility_off' }}
            </mat-icon>
            <mat-error
              *ngIf="
                passwordModel.invalid &&
                (passwordModel.dirty || passwordModel.touched)
              "
            >
              <mat-error
                *ngIf="passwordModel.errors.required"
                class="input-gray__error"
              >
                {{ translationPath + 'requiredPasswordMessage' | translate }}
              </mat-error>
            </mat-error>
          </mat-form-field>
          <button
            mat-flat-button
            type="submit"
            class="primary-button w-fit"
            tabindex="3"
            [disabled]="
              loginForm.invalid && (loginForm.dirty || loginForm.touched)
            "
          >
            {{ translationPath + 'loginBtnLabel' | translate | uppercase }}
          </button>
        </form>
      </div>
      <hr class="w-full margin-t margin-b">
      <div class="flex justify-center items-center flex-col w-fit">
        <!--onclick="window.open('https://identity.gatv.es/realms/MotivateXR/protocol/openid-connect/auth?client_id=kayrox&redirect_uri=' + window.location.origin + '/tiwp/rest_api/callback&response_type=code&scope=openid', '_blank')"-->
        <button
          mat-flat-button
          class="primary-button w-fit"
          tabindex="4"
          (click)="loginMotivateXR()"
        >
          {{ translationPath + 'motivateXrAuthBtnLabel' | translate | uppercase }}
        </button>

        <hr class="w-full margin-t margin-b">

        <!--onclick="window.open('https://sso.tecnalia.com/realms/TRI/protocol/openid-connect/auth?client_id=tec-kayrox-visual&redirect_uri=' + window.location.origin + '/tiwp/rest_api/callback&response_type=code&scope=openid', '_blank')"-->
        <button
          mat-flat-button
          class="primary-button max-w-full"
          tabindex="5"
          (click)="loginTecnalia()"
        >
          {{ translationPath + 'tecnaliaAuthBtnLabel' | translate | uppercase }}
        </button>
      </div>

      <hr class="w-full  margin-t">
    </div>
  </div>
</div>
